// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getOrders } from "@ces/App/Services/OrderService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import {
    chain,
    RequestDataFromApi,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrders";

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    const fields = {
        orderDate: "enteredDate",
        webOrderNumber: "invoiceNumber",
        "erpOrderNumber DESC": "",
    };
    let sort = props.parameter.sort;
    Object.entries(fields).forEach(([field, apiField]) => {
        sort = sort?.replace(field, apiField);
    });
    sort = sort
        ?.split(",")
        .filter(x => !!x)
        .join(",");
    props.apiParameter = { ...props.parameter, sort };
};

export const XngRequestDataFromApi: typeof RequestDataFromApi = async props => {
    try {
        props.apiResult = await getOrders(props.apiParameter);
    } catch (error) {
        logger.error(error);
    }
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
